module.exports = __webpack_public_path__ + "static/img/cdb4.0c7dbede.png";